import imagesLoaded from 'imagesloaded'

export default {
  data() {
    return {
      loader: null,
    }
  },
  beforeDestroy() {
    this.loader = null
  },
  methods: {
    $_imageLoader_load(el) {
      return new Promise((resolve) => {
        this.loader = imagesLoaded(el)

        this.loader.on('always', (instance) => {
          resolve(instance)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/image-loader.js